import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { LanguageService } from '../services/language.service';

/**
 * Attaches the current UI language as a `locale` query param on every
 * outgoing API request so the Laravel backend (middleware `locale.request`)
 * can return server-localized strings — room amenities, notifications, etc.
 * — in the language the user is currently viewing.
 *
 * A query param is used instead of a header to avoid the CORS preflight
 * that a custom header would trigger cross-origin (the API runs on a
 * different host from the SPA in every deployed environment).
 *
 * Only known third-party hosts are skipped.
 */
const THIRD_PARTY_HOSTS = [
  'nominatim.openstreetmap.org',
];

export const localeInterceptor: HttpInterceptorFn = (req, next) => {
  if (THIRD_PARTY_HOSTS.some(host => req.url.includes(host))) {
    return next(req);
  }

  const languageService = inject(LanguageService);
  const locale = languageService.getCurrentLanguage();

  // Don't overwrite an explicit `locale` the caller already set.
  if (!locale || req.params.has('locale')) {
    return next(req);
  }

  return next(req.clone({ params: req.params.set('locale', locale) }));
};
